export default __webpack_public_path__ + "static/media/flood.37db197b.svg";